export enum ResizeDirection {
  Start = -1,
  Center = 0,
  End = 1,
}
